import format from "date-fns/format";
import { DATE_PATTERN } from "../common/constants/date";
//
export const formatDateLabel = (item, pattern = DATE_PATTERN) =>
  `${format(new Date(item.startDate), pattern)} to ${format(new Date(item.endDate), pattern)}`;
